import {Card, CardHeader, Divider, makeStyles, Text, tokens} from "@fluentui/react-components";
import {BUSINESS_UNIT_MAP, truncate} from "../../util";
import * as React from "react";
import AppBadge from "./AppBadge";

interface TemplateItemProps {
    id: string;
    title: string;
    businessUnit: string;
    description: string;
    tags: string[];
    onClick?: () => void;
}

const useStyles = makeStyles({
    businessUnit: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        width: '100%',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalS,
    },
    card: {
        cursor: 'pointer',
        borderLeftWidth: '4px',
        borderLeftStyle: 'solid',
    },
    description: {
        color: tokens.colorNeutralForeground3,
    },
    tags: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalXS,
        marginTop: tokens.spacingVerticalXS,
    },
    empty: {
        color: tokens.colorNeutralForeground3,
    }
});

export default function TemplateItem(props: Readonly<TemplateItemProps>) {
    const styles = useStyles();

    return (
        <Card
            key={props.id}
            className={styles.card}
            style={{borderLeftColor: BUSINESS_UNIT_MAP[props.businessUnit].color}}
            onClick={(_) => props.onClick?.()}
        >
            <CardHeader
                header={
                    <Text weight="semibold" size={400}>
                        {props.title}
                    </Text>
                }
                description={
                    <div className={styles.businessUnit}>
                        <Text
                            size={200}
                            style={{color: BUSINESS_UNIT_MAP[props.businessUnit].color, fontSize: '11px'}}
                        >
                            {BUSINESS_UNIT_MAP[props.businessUnit].label}
                        </Text>
                        <Divider style={{borderTopColor: BUSINESS_UNIT_MAP[props.businessUnit].color}}/>
                    </div>
                }
            />

            {props.description &&
                <Text className={styles.description} size={200}>{truncate(props.description, 140)}</Text>}

            {props.tags && props.tags.length > 0 && (
                <div className={styles.tags}>
                    {props.tags.map((tag) => (
                        <AppBadge key={`badge_${props.id}_${tag}`}>{tag}</AppBadge>
                    ))}
                </div>
            )}
        </Card>
    );
}

